module.exports = __webpack_public_path__ + "img/123.0a47d40a.png";